import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { utils, write, WorkBook } from 'xlsx';

interface AiChatDownloadSheet {
  name: string;
  data: any[][];
}

export interface AiChatDownloadData {
  type: string;
  filename: string;
  sheets: AiChatDownloadSheet[];
}

@Component({
  selector: 'app-ai-chat-download',
  templateUrl: './ai-chat-download.component.html',
  styleUrls: ['./ai-chat-download.component.scss'],
})
export class AiChatDownloadComponent implements OnInit, OnDestroy {
  @Input() downloadData!: AiChatDownloadData;
  @Output() downloadStarted = new EventEmitter<void>();

  fileSize = '';

  private blob!: Blob;
  private blobUrl = '';

  ngOnInit(): void {
    this.buildDownload();
  }

  ngOnDestroy(): void {
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl);
    }
  }

  downloadFile(event?: Event): void {
    event?.stopPropagation();

    if (!this.blobUrl) {
      return;
    }

    const link = document.createElement('a');
    link.href = this.blobUrl;
    link.download = this.downloadData?.filename || 'archivo.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    this.downloadStarted.emit();
  }

  private buildDownload(): void {
    const sheets = Array.isArray(this.downloadData?.sheets)
      ? this.downloadData.sheets
      : [];

    const workbook: WorkBook = utils.book_new();

    sheets.forEach((sheet) => {
      const worksheet = utils.aoa_to_sheet(Array.isArray(sheet?.data) ? sheet.data : []);
      utils.book_append_sheet(workbook, worksheet, sheet?.name || 'Hoja');
    });

    const buffer = write(workbook, { bookType: 'xlsx', type: 'array' });
    this.blob = new Blob([buffer], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });
    this.blobUrl = URL.createObjectURL(this.blob);
    this.fileSize = this.formatFileSize(this.blob.size);
  }

  private formatFileSize(bytes: number): string {
    if (!bytes) {
      return '0 B';
    }

    const units = ['B', 'KB', 'MB', 'GB'];
    const k = 1024;
    const i = Math.min(Math.floor(Math.log(bytes) / Math.log(k)), units.length - 1);
    const size = parseFloat((bytes / Math.pow(k, i)).toFixed(2));

    return `${size} ${units[i]}`;
  }
}
